import { convertEntry } from "./convertEntry";
import { EntryType } from "../types";
import { getFileList } from "../../../../api/googleDrive/getFileList";

export const fetchFileList = (id?: string) => (
  getFileList(id)
    .then(files => files
      .map(convertEntry)
      .filter(({ type }) => type !== EntryType.unknown))
    .catch(() => {
      throw new Error("Google Drive");
    })
);
